<template>
  <q-scroll-area ref="scroll" style="height: 100px; width: 100%" class="bs bs-q-scroll-area bs-q-scroll-area-lineContents">
    <div class="lineContents-txt-area">
      <span class="item" v-for="(val, index) in value">
        {{ val }}
        <q-btn :auth-force="true" size="sm" round class="bs bs-q-btn-sm bs-q-btn-round-icon" @click="remove(val)">
          <span class="bs-q-btn-round-icon bs-q-btn-round-icon-delete"></span>
        </q-btn>
        {{ (index !== (value.length - 1)) ? ', ': '' }}
      </span>
    </div>
  </q-scroll-area>
</template>

<script>
  export default {
    name: 'filter-input-list',
    props: {
      value: { // 'text', 'number', 'ip'
        type: Array,
        default: []
      }
    },
    data () {
      return {
        arrVal: []
      }
    },
    methods: {
      remove (str) {
        const findIdx = _.findIndex(this.arrVal, (val) => { return val === str })
        if (findIdx > -1) {
          this.arrVal.splice(findIdx, 1)
          this.onUpdate()
        }
      },
      onUpdate () {
        this.$emit('input', this.arrVal)
      }
    },
    mounted () {
    },
    watch: {
      value () {
        this.arrVal = this.value
      }
    }
  }
</script>

<style scoped>

</style>
